/**
 * Rocksoft Locations Settings API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { AddWifiProfileToCategoryCommand } from '../model/addWifiProfileToCategoryCommand';
// @ts-ignore
import { CategoryType } from '../model/categoryType';
// @ts-ignore
import { CategoryWifiProfileConfiguration } from '../model/categoryWifiProfileConfiguration';
// @ts-ignore
import { ErrorResponse } from '../model/errorResponse';
// @ts-ignore
import { ModelNameFlags } from '../model/modelNameFlags';
// @ts-ignore
import { SetWifiProfilesForCategoryCommand } from '../model/setWifiProfilesForCategoryCommand';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';


export interface AddWifiProfileToCategoryRequestParams {
    /** The type of the category. */
    categoryType: CategoryType;
    /** The persistent id of the category. */
    categoryId: string;
    /** The command that contains the data of the Wi-Fi profile. */
    addWifiProfileToCategoryCommand?: AddWifiProfileToCategoryCommand;
}

export interface DeleteWifiProfileFromCategoryRequestParams {
    /** The type of the category. */
    categoryType: CategoryType;
    /** The persistent id of the category. */
    categoryId: string;
    /** The id of the Wi-Fi profile. */
    wifiProfileId: string;
    /** Optional, the models to filter on. */
    models?: Array<ModelNameFlags>;
}

export interface GetWifiProfileForCategoryRequestParams {
    /** The type of the category. */
    categoryType: CategoryType;
    /** The persistent id of the category. */
    categoryId: string;
    /** The id of the Wi-Fi profile preset. */
    wifiProfilePresetId: string;
}

export interface GetWifiProfilesForCategoryRequestParams {
    /** The type of the category. */
    categoryType: CategoryType;
    /** The persistent id of the category. */
    categoryId: string;
}

export interface PutWifiProfileToCategoryRequestParams {
    /** The type of the category. */
    categoryType: CategoryType;
    /** The persistent id of the category. */
    categoryId: string;
    /** The command that contains the data of the Wi-Fi profiles. */
    setWifiProfilesForCategoryCommand?: SetWifiProfilesForCategoryCommand;
}


@Injectable({
  providedIn: 'root'
})
export class CategoryWifiProfileConfigurationService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Adds a Wi-Fi profile to a category. If the Wi-Fi profile already exists for the category, it will be updated. The Wi-Fi profile preset must exist before calling this API, otherwise a 404 Not Found response will be returned. If the category does not exist, a 404 Not Found response will be returned.
     * @endpoint post /categories/{categoryType}/{categoryId}/integrations/mdm/wifi-profiles
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public addWifiProfileToCategory(requestParameters: AddWifiProfileToCategoryRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CategoryWifiProfileConfiguration>;
    public addWifiProfileToCategory(requestParameters: AddWifiProfileToCategoryRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CategoryWifiProfileConfiguration>>;
    public addWifiProfileToCategory(requestParameters: AddWifiProfileToCategoryRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CategoryWifiProfileConfiguration>>;
    public addWifiProfileToCategory(requestParameters: AddWifiProfileToCategoryRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const categoryType = requestParameters?.categoryType;
        if (categoryType === null || categoryType === undefined) {
            throw new Error('Required parameter categoryType was null or undefined when calling addWifiProfileToCategory.');
        }
        const categoryId = requestParameters?.categoryId;
        if (categoryId === null || categoryId === undefined) {
            throw new Error('Required parameter categoryId was null or undefined when calling addWifiProfileToCategory.');
        }
        const addWifiProfileToCategoryCommand = requestParameters?.addWifiProfileToCategoryCommand;

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/categories/${this.configuration.encodeParam({name: "categoryType", value: categoryType, in: "path", style: "simple", explode: false, dataType: "CategoryType", dataFormat: undefined})}/${this.configuration.encodeParam({name: "categoryId", value: categoryId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/integrations/mdm/wifi-profiles`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CategoryWifiProfileConfiguration>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: addWifiProfileToCategoryCommand,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Deletes a Wi-Fi profile from a category. If the Wi-Fi profile does not exist for the category, nothing will happen.
     * @endpoint delete /categories/{categoryType}/{categoryId}/integrations/mdm/wifi-profiles/{wifiProfileId}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public deleteWifiProfileFromCategory(requestParameters: DeleteWifiProfileFromCategoryRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteWifiProfileFromCategory(requestParameters: DeleteWifiProfileFromCategoryRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteWifiProfileFromCategory(requestParameters: DeleteWifiProfileFromCategoryRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteWifiProfileFromCategory(requestParameters: DeleteWifiProfileFromCategoryRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const categoryType = requestParameters?.categoryType;
        if (categoryType === null || categoryType === undefined) {
            throw new Error('Required parameter categoryType was null or undefined when calling deleteWifiProfileFromCategory.');
        }
        const categoryId = requestParameters?.categoryId;
        if (categoryId === null || categoryId === undefined) {
            throw new Error('Required parameter categoryId was null or undefined when calling deleteWifiProfileFromCategory.');
        }
        const wifiProfileId = requestParameters?.wifiProfileId;
        if (wifiProfileId === null || wifiProfileId === undefined) {
            throw new Error('Required parameter wifiProfileId was null or undefined when calling deleteWifiProfileFromCategory.');
        }
        const models = requestParameters?.models;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'models',
            <any>models,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/categories/${this.configuration.encodeParam({name: "categoryType", value: categoryType, in: "path", style: "simple", explode: false, dataType: "CategoryType", dataFormat: undefined})}/${this.configuration.encodeParam({name: "categoryId", value: categoryId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/integrations/mdm/wifi-profiles/${this.configuration.encodeParam({name: "wifiProfileId", value: wifiProfileId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a specific Wi-Fi profile for a category by the Wi-Fi profile preset id.
     * @endpoint get /categories/{categoryType}/{categoryId}/integrations/mdm/wifi-profiles/{wifiProfilePresetId}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getWifiProfileForCategory(requestParameters: GetWifiProfileForCategoryRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CategoryWifiProfileConfiguration>;
    public getWifiProfileForCategory(requestParameters: GetWifiProfileForCategoryRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CategoryWifiProfileConfiguration>>;
    public getWifiProfileForCategory(requestParameters: GetWifiProfileForCategoryRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CategoryWifiProfileConfiguration>>;
    public getWifiProfileForCategory(requestParameters: GetWifiProfileForCategoryRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const categoryType = requestParameters?.categoryType;
        if (categoryType === null || categoryType === undefined) {
            throw new Error('Required parameter categoryType was null or undefined when calling getWifiProfileForCategory.');
        }
        const categoryId = requestParameters?.categoryId;
        if (categoryId === null || categoryId === undefined) {
            throw new Error('Required parameter categoryId was null or undefined when calling getWifiProfileForCategory.');
        }
        const wifiProfilePresetId = requestParameters?.wifiProfilePresetId;
        if (wifiProfilePresetId === null || wifiProfilePresetId === undefined) {
            throw new Error('Required parameter wifiProfilePresetId was null or undefined when calling getWifiProfileForCategory.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/categories/${this.configuration.encodeParam({name: "categoryType", value: categoryType, in: "path", style: "simple", explode: false, dataType: "CategoryType", dataFormat: undefined})}/${this.configuration.encodeParam({name: "categoryId", value: categoryId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/integrations/mdm/wifi-profiles/${this.configuration.encodeParam({name: "wifiProfilePresetId", value: wifiProfilePresetId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CategoryWifiProfileConfiguration>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets the Wi-Fi profiles for a category.
     * @endpoint get /categories/{categoryType}/{categoryId}/integrations/mdm/wifi-profiles
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getWifiProfilesForCategory(requestParameters: GetWifiProfilesForCategoryRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<CategoryWifiProfileConfiguration>>;
    public getWifiProfilesForCategory(requestParameters: GetWifiProfilesForCategoryRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<CategoryWifiProfileConfiguration>>>;
    public getWifiProfilesForCategory(requestParameters: GetWifiProfilesForCategoryRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<CategoryWifiProfileConfiguration>>>;
    public getWifiProfilesForCategory(requestParameters: GetWifiProfilesForCategoryRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const categoryType = requestParameters?.categoryType;
        if (categoryType === null || categoryType === undefined) {
            throw new Error('Required parameter categoryType was null or undefined when calling getWifiProfilesForCategory.');
        }
        const categoryId = requestParameters?.categoryId;
        if (categoryId === null || categoryId === undefined) {
            throw new Error('Required parameter categoryId was null or undefined when calling getWifiProfilesForCategory.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/categories/${this.configuration.encodeParam({name: "categoryType", value: categoryType, in: "path", style: "simple", explode: false, dataType: "CategoryType", dataFormat: undefined})}/${this.configuration.encodeParam({name: "categoryId", value: categoryId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/integrations/mdm/wifi-profiles`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<CategoryWifiProfileConfiguration>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates the Wi-Fi profiles for a category. If the Wi-Fi profiles already exist for the category, they will be updated. If a Wi-Fi profile does not exist for the category, it will be added. The Wi-Fi profile presets must exist before calling this API, otherwise a 404 Not Found response will be returned. If the category does not exist, a 404 Not Found response will be returned.
     * @endpoint put /categories/{categoryType}/{categoryId}/integrations/mdm/wifi-profiles
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public putWifiProfileToCategory(requestParameters: PutWifiProfileToCategoryRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<CategoryWifiProfileConfiguration>>;
    public putWifiProfileToCategory(requestParameters: PutWifiProfileToCategoryRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<CategoryWifiProfileConfiguration>>>;
    public putWifiProfileToCategory(requestParameters: PutWifiProfileToCategoryRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<CategoryWifiProfileConfiguration>>>;
    public putWifiProfileToCategory(requestParameters: PutWifiProfileToCategoryRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const categoryType = requestParameters?.categoryType;
        if (categoryType === null || categoryType === undefined) {
            throw new Error('Required parameter categoryType was null or undefined when calling putWifiProfileToCategory.');
        }
        const categoryId = requestParameters?.categoryId;
        if (categoryId === null || categoryId === undefined) {
            throw new Error('Required parameter categoryId was null or undefined when calling putWifiProfileToCategory.');
        }
        const setWifiProfilesForCategoryCommand = requestParameters?.setWifiProfilesForCategoryCommand;

        let localVarHeaders = this.defaultHeaders;

        // authentication (azureb2c) required
        localVarHeaders = this.configuration.addCredentialToHeaders('azureb2c', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/categories/${this.configuration.encodeParam({name: "categoryType", value: categoryType, in: "path", style: "simple", explode: false, dataType: "CategoryType", dataFormat: undefined})}/${this.configuration.encodeParam({name: "categoryId", value: categoryId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/integrations/mdm/wifi-profiles`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<CategoryWifiProfileConfiguration>>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: setWifiProfilesForCategoryCommand,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
